import { computed } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { TagState } from './tag.state';
import { StateFilter } from '../crud.state';
import { Tag } from '../../models/tag';

const filterItems = (items: Tag[], filter: StateFilter, products = false) => {
  return items.filter(item => {
    const titleMatch = item.title
      .toLowerCase()
      .includes(filter.query.toLowerCase());
    const typeMatch = products ? item.type === 1 : item.type !== 1;

    const idMatch =
      !filter.ids ||
      filter.ids.length === 0 ||
      filter.ids.includes(item._id) ||
      filter.ids.includes(item._id);

    return titleMatch && typeMatch && idMatch;
  });
};

export function withTagSelectors() {
  return signalStoreFeature(
    {
      state: type<TagState>(),
    },
    withComputed(({ items, filter, selection }) => ({
      count: computed(() => Object.keys(items()).length),
      asArray: computed(() => {
        return Object.values(items())
          .filter(tag => tag.commune !== null)
          .sort((a, b) => (a.title < b.title ? -1 : 1));
      }),
      globalTags: computed(() => {
        const filtered = Object.values(items()).filter(
          tag => tag.commune === null
        );
        return filtered.sort((a, b) => (a.title < b.title ? -1 : 1));
      }),
      allAsArray: computed(() => {
        const filtered = Object.values(items());
        return filtered.sort((a, b) => (a.title < b.title ? -1 : 1));
      }),
      allTitles: computed(() => {
        return Object.values(items()).map((item: Tag) => item.title);
      }),
      allTitlesLowerCase: computed(() => {
        return Object.values(items()).map((item: Tag) =>
          item.title.toLowerCase().trim()
        );
      }),
      filteredSortedByName: computed(() => {
        let filtered = Object.values(items());
        if (filter()) {
          filtered = filterItems(filtered, filter());
        }
        return filtered.sort((a, b) => (a.title < b.title ? -1 : 1));
      }),
      filteredSelection: computed(() => {
        let filtered = selection();
        if (filter()) {
          filtered = filterItems(filtered, filter());
        }
        return filtered as Tag[];
      }),
      products: computed(() => {
        let filtered = Object.values(items());
        if (filter()) {
          filtered = filterItems(filtered, filter(), true);
        }
        return filtered.sort((a, b) => (a.title < b.title ? -1 : 1));
      }),
    }))
  );
}
